import React, { Component } from "react";
import NavMenu from "../../navmenu/NavMenu";
import Footer from "../../footer/Footer";
import "../../../styles/pages/contact/Contact.css";

export default class Contact extends Component {
  render() {
    return (
      <div className="Contact page-wrapper">
        <NavMenu />

        <div className="content-wrapper gutters">
          <div className="title-container">
            <div className="title-word-container">
              <div className="title faded">GET IN TOUCH,</div>
            </div>
            <div className="title-word-container">
              <div className="title faded">ASK QUESTIONS,</div>
            </div>
            <div className="title-word-container">
              <div className="title faded">SAY HELLO,</div>
            </div>
            <div className="title-word-container">
              <div className="title">CALL GAGE.</div>
            </div>
          </div>
          <div className="details-container">
            <div className="faded-sub-text">
              No - You don't actually call Gage...
            </div>
          </div>
        </div>

        <Footer page={"contact"} />
      </div>
    );
  }
}
